<template>
    <div class="transfer acccont">
        <div class="acctit">
            <div @click="returnpage" class="returnbtn" v-if="isApp"><i class="el-icon-arrow-left"></i></div>
            {{$t('account.transfer')}}
        </div>
        <div v-if="isApp">
            <div class="flexbox lctitbox">
                <img src="../../assets/imgs/qd.png">
                <div class="texal">
                    <div class="colory fontw">{{user.money}}<span class="minim"> ≈ ${{user.money}}</span></div>
                    <div>{{$t('account.balance')}}</div>
                    <div class="colory fontw posrbtn" v-if="!user.user_id" @click="$router.push({path: '/login'})">{{$t('account.login')}}</div>
                </div>
            </div>
        </div>
        <div>
            <div class="texac">
                <div class="formbox">
                    <div class="accctit" v-if="!isApp">
                        {{$t('account.transfer')}}
                    </div>
                    <el-form :model="ruleForm" ref="ruleForm" label-width="120px">
                        <el-form-item :label="$t('account.transfer_to_user')" prop="toUser">
                            <el-input prefix-icon="el-icon-user" type="text" v-model="ruleForm.toUser"
                                      :placeholder="$t('account.input_transfer_to_user')"
                                      autocomplete="off"></el-input>
                            <div class="formtip">{{$t('account.transfer_to_user_tip')}}</div>
                        </el-form-item>
                        <el-form-item :label="$t('account.transfer_amount')" prop="money">
                            <el-input prefix-icon="el-icon-money" type="number" v-model="ruleForm.money"
                                      :placeholder="$t('account.input_transfer_amount')"
                                      autocomplete="off"></el-input>
                            <div class="formtip">{{$t('account.transfer_amount_tip')}}</div>
                        </el-form-item>
                        <!--<el-form-item :label="$t('account.trader_password')" prop="payPassword">
                            <el-input prefix-icon="el-icon-key" type="password" v-model="ruleForm.payPassword"
                                      :placeholder="$t('account.input_trader_password')"
                                      autocomplete="off"></el-input>
                        </el-form-item>-->
                        <div class="btnn bgb texac" @click="submitForm('ruleForm')">{{$t('account.transfer_confirm')}}</div>
                    </el-form>
                </div>
            </div>
        </div>
        <el-dialog :title="$t('account.wallet_address')" :visible.sync="dialogVisible" :width="isApp ? '92%': '40%'" :before-close="handleClose">
            <el-form :model="ruleForm2"  ref="ruleForm2" label-width="0%">
                <el-form-item label="" prop="walletAddress">
                    <el-select v-model="ruleForm2.walletAddress" class="selebox"
                               :placeholder="$t('account.select_transfer_wallet')" style="width: 100%">
                        <i slot="prefix" class="el-input__icon el-icon-postcard"></i>
                        <el-option v-for="item in walletList" :key="item.value" :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-button type="primary" @click="dialogVisibleYes" style="background: #1750cc">{{$t('account.confirm')}}</el-button>
            </el-form>
        </el-dialog>
        <div class="loadpop" v-show="connectVisible">
            <div class="centerF" >
                <img src="../../assets/imgs/load1.gif" alt="" >
                <p class="num">{{persentText}}</p>
                <div>{{connectMessage}}</div>
            </div>
            <span slot="footer" class="dialog-footer"></span>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {getInfo} from '@/api/account'
    import {
        do_transfer, vip_transfer
    } from '@/api/transfer.js'

    export default {
        name: 'transFer',
        data() {

            let validateToUser = (rule, value, callback) => {
                if (value.trim() == "") {
                    // this.$message.error(this.$t('account.input_transfer_to_user'));
                    callback(new Error(this.$t('account.input_transfer_to_user')));
                } else {
                    callback();
                }
            };
            let checkMoney = (rule, value, callback) => {
                if (value.trim() == "") {
                    //this.$message.error('邮箱不能为空');
                    callback(new Error(this.$t('account.input_transfer_amount')));
                } else if (Number(value) <= 0) {
                    callback(new Error(this.$t('account.input_right_transfer_amount')));
                } else {
                    callback();
                }
            };
            let validatePayPass = (rule, value, callback) => {
                if (value.trim() == "") {
                    //this.$message.error('请输入密码');
                    callback(new Error(this.$t('account.input_your_trader_password')));
                } else {
                    callback();
                }
            };
            let walletAddress = (rule, value, callback) => {
                if (value.trim() == "") {
                    callback(new Error(this.$t('account.select_wallet_address')));
                } else {
                    callback();
                }
            };
            return {
                user: {
                    user_id: -1,
                    money: '0.00',
                },
                ruleForm: {
                    toUser: '',
                    money: '',
                    // payPassword: ''
                },
                ruleForm2: {
                    walletAddress: '',
                    transferFee: '',
                    transferFeeRate: '',
                    toUser: '',
                    money: '',
                },
                walletList: [],
                dialogVisible: false,
                connectVisible: false,
                setIntervalIndex: null,
                persentText: '',
                rules: {
                    money: [{
                        validator: checkMoney,
                        trigger: "blur"
                    }],

                    toUser: [{
                        validator: validateToUser,
                        trigger: "blur"
                    }],
                    // payPassword: [{
                    //     validator: validatePayPass,
                    //     trigger: "blur"
                    // }]
                },
                rules2: {
                    walletAddress: [{
                        validator: walletAddress,
                        trigger: "blur"
                    }],

                },
                sn: '',
                connectMessage: '',
                connectMessageList: [],
            }
        },
        computed: {
            isApp() {
                return document.documentElement.clientWidth < 800 ? true : false
            },
            routeName() {
                console.log(this.$route.path)
                return this.$route.path
            }
        },
        created() {
            this.getData()
        },
        destroyed(){
            clearInterval(this.setIntervalIndex); //清除定时器
        },
        methods: {
            returnpage() {
                this.$router.go(-1)
            },
            getData() {
                getInfo().then(res => {
                    const data = res.data
                    this.user = data.user
                    this.sn = data.sn
                    this.connectMessageList = data.connectMessageList
                }).catch(_ => {

                })
            },
            //取消弹窗
            handleClose(done) {
                this.dialogVisible = false;
            },
            //弹窗确定
            dialogVisibleYes() {
                if(!this.ruleForm2.walletAddress){
                    this.$message.error(this.$t('account.select_wallet_address'))
                    return false
                }
                this.dialogVisible = false;
                let that = this
                const loading = this.$loading({
                    lock: true,//lock的修改符--默认是false
                    text: this.$t('account.transfer_checking'),//显示在加载图标下方的加载文案
                    spinner: 'el-icon-loading',//自定义加载图标类名
                    background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
                    target: document.querySelector('.transfer')//loadin覆盖的dom元素节点
                });
                //成功回调函数停止加载
                setTimeout(() => {
                    loading.close();
                    that.confirmWallet();
                }, 2000);

            },
            confirmWallet(){
                let that = this
                this.$prompt(
                    this.$t('account.trader_confirm_wallet_address'),
                    this.$t('account.trader_tips'), {
                        confirmButtonText: this.$t('account.trader_confirm'),
                        cancelButtonText: this.$t('account.trader_cancel'),
                        type: "warning", // 图标样式 "warning"|"error"...
                        inputValue: '',
                        inputErrorMessage: '',
                        customClass: 'message-logout',
                        inputValidator: (value) => { // 点击按钮时，对文本框里面的值进行验证
                            if (!value) {
                                return this.$t('account.trader_input_wallet_address');
                            }else if(value != that.ruleForm2.walletAddress){
                                return this.$t('account.trader_wallet_address_must_be_consistent');
                            }
                        },
                        callback: function(action, instance) {
                            if (action === 'confirm') {
                                // do something...
                                that.vipTransfer()
                            }
                        }
                    }).then(({
                                 value
                             }) => {
                    console.log(value);
                    // TO DO DO ...
                }).catch((err) => {
                    console.log(err);
                })
            },
            vipTransfer() {
                let that = this
                vip_transfer(this.ruleForm2).then(res => {
                    if (res.code == 1) {
                        setTimeout(function() {
                            that.sn = res.data.sn
                            that.connectMessageList = res.data.connectMessageList
                            that.showConnect()
                        }, 500);
                    } else {
                        this.$message.error(res.msg)
                    }

                }).catch(_ => {

                })

            },

            showConnect(){
                this.connectVisible = true
                let that = this
                let persentNum = 0
                this.setIntervalIndex = setInterval(() => {
                    let rand = Math.floor(Math.random()*3+1)
                    for (let index = 1; index < rand + 1; index ++ ) {
                        persentNum = persentNum + 1;
                        if(persentNum > 67 && persentNum < 1000){
                            that.connectMessage = that.connectMessageList[2]
                        }else if(persentNum > 34 && persentNum <= 67){
                            that.connectMessage = that.connectMessageList[1]
                        }else if(persentNum >= 0 && persentNum <= 34){
                            that.connectMessage = that.connectMessageList[0]
                        }
                        if (persentNum >= 100) {
                            persentNum = 100
                            that.persentText = persentNum + '%'
                            clearInterval(that.setIntervalIndex) //清除定时器
                            that.goTransfer()
                            break
                        }else{
                            that.persentText = persentNum + '%'
                        }
                    }



                }, 100)
            },
            goTransfer(){
                this.connectVisible = false
                this.$router.push({
                    // path: '/home/viptransfer?sn=E2022122722463910254981&toUser=admin'
                    path: '/home/viptransfer?sn='+this.sn+'&toUser=' + this.ruleForm.toUser
                })
                this.ruleForm.toUser = ""
                this.ruleForm.money = ""
                // this.$router.replace('/home/viptransfer?sn='+this.sn+'&toUser=' + this.ruleForm.toUser)
            },

            submitForm(formName) {
                let that = this;

                if (this.ruleForm.toUser.length == 0) {
                    this.$message.error(this.$t('account.input_transfer_to_user'))
                    return false
                }
                if (this.ruleForm.money.length == 0) {
                    this.$message.error(this.$t('account.input_transfer_amount'))
                    return false
                }
                if (Number(this.ruleForm.money) <= 0) {
                    this.$message.error(this.$t('account.input_right_transfer_amount'))
                    return false
                }
                do_transfer(this.ruleForm).then(res => {
                    if (res.code == 1) {
                        this.$message.success(res.msg);
                        this.ruleForm.money = "";
                        this.ruleForm.toUser = "";
                        // this.ruleForm.payPassword = "";
                        that.getData()
                    } else if (res.code == 2) {
                        this.dialogVisible = true
                        this.ruleForm2.transferFee = res.data.transfer_fee
                        this.ruleForm2.transferFeeRate = res.data.transfer_fee_rate
                        this.ruleForm2.money = this.ruleForm.money
                        this.ruleForm2.toUser = this.ruleForm.toUser
                        this.walletList = res.data.wallet_list
                    } else {
                        this.$message.error(res.msg)
                    }

                }).catch(_ => {

                });
            },
            handleSuccess() {

            },
            handleRemove() {

            }
        }
    }
</script>
<style lang="scss" scoped>
    .transfer {
        font-size: 18px;

        .lctitbox {
            background: rgb(36, 36, 36);
            padding: 10px;
            font-size: 16px;
            box-sizing: border-box;
            border-radius: 10px;
            margin-top: 10px;
            .fontw {
                line-height: 40px;
                font-size: 20px;
                font-weight: bold;
            }

            img {
                width: 80px;
                height: 80px;
                padding-right: 30px;
            }
        }

        .accctit {
            font-size: 24px;
            font-weight: bold;
            line-height: 80px;
        }

        .tiplin {
            line-height: 40px;
        }

        .marr {
            text-align: center;
            line-height: 26px;

            img {
                width: 200px;
                height: 200px;
                margin-right: 30px;
            }
        }

        .gzimgbox {
            width: 60%;
            margin: 20px auto;
        }

        .examplelistbox {
            img {
                width: 300px;
                height: 600px;
            }
        }

        .formbox {
            width: 60%;
            margin: 30px auto;
            padding: 30px;
            border-radius: 20px;
            border: 1px solid rgb(85, 85, 85);

            .bgb {
                margin: 40px 0px 20px 0px;
                padding: 14px 30px;
                background: #1750cc;
                color: #fff;
                font-size: 20px;
            }
        }
    }
    .loadpop{

    }
</style>
<style lang="scss">

    .loadpop{
        z-index: 9999999999999;
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,.9);
        .centerF{
            width: 50%;
            .num{
                font-size: 24px;
                color: orange;
            }
            img{
                width: 40%;
                margin: 20px auto 0px
            }
        }

    }
    .el-dialog{
        display: flex;
        display: -ms-flex; /* 兼容IE */
        flex-direction: column;
        -ms-flex-direction: column; /* 兼容IE */
        margin:0 !important;
        position:absolute;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%);
        max-height:calc(100% - 30px);
        max-width:calc(100% - 30px);
    }
    .el-dialog .el-dialog__body{
        max-height: 100%;
        flex: 1;
        -ms-flex: 1 1 auto; /* 兼容IE */
        overflow-y: auto;
        overflow-x: hidden;
    }

    .el-dialog__wrapper {
        /*隐藏ie和edge中遮罩的滚动条*/
        overflow: hidden;
    }
    @media (max-width: 730px) {
       .loadpop{
           .centerF{
               width: 80%;
               .num{
                   font-size: 18px;
                   color: orange;
               }
               img{
                   width: 80%;
                   margin: 20px auto 0px
               }
           }
       }
       }
</style>
<style>
    @media (max-width: 730px) {
        .message-logout {
            width: 92% !important;
        }
    }
</style>
